
<template>
	<div class="log-out">
		<div class="header2">Logging out ...</div>
		<br />
		<br />
		<br />
		<div class="header5">Redirecting to homepage</div>
	</div>
</template>
<script>
import { AUTH_LOGOUT } from "../store/constants";

export default {
	name: "logout",
	title: "Logout",
	data() {
		return {};
	},
	created: async function () {
		await this.$store.dispatch(AUTH_LOGOUT);
		window.location = "/";
	},
};
</script>
<style scoped lang="scss">
.log-out {
	background: var(--dark-blue);
	height: 100%;
	padding-bottom: 5vw;
	width: 100%;
	padding: 9vw 5vw;
	.header5 {
		color: var(--accent);
		font-size: 18px;
		margin-bottom: 20px;
	}
	.header2 {
		color: var(--white);
		font-size: 51px;
		line-height: 51px;
	}
}
</style>
